import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO 
        title="404 - Siden blev ikke fundet" 
        description="Beklager, siden du leder efter findes ikke hos Fyns - Tømreren ApS. Find vej tilbage til vores forside eller ydelser." 
        noIndex={true}
      />

      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F5F5] py-20 px-4">
        <div className="max-w-md w-full bg-white p-8 sm:p-10 shadow-sm border border-gray-200 text-center space-y-6">
          <div className="w-20 h-20 bg-[#1F2A37] text-[#3A5A40] flex items-center justify-center text-3xl mx-auto">
            <i className="fa-solid fa-triangle-exclamation"></i>
          </div>
          
          <div className="space-y-2">
            <span className="text-4xl font-extrabold text-[#111111]">404</span>
            <h1 className="text-2xl font-bold text-[#111111]">Side findes ikke</h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              Siden du forsøgte at tilgå eksisterer ikke eller er blevet flyttet.
            </p>
          </div>

          <div className="pt-2">
            <Link
              to="/"
              className="inline-block bg-[#3A5A40] hover:bg-[#2D4632] text-white px-6 py-3 font-semibold text-sm transition-colors"
            >
              <i className="fa-solid fa-house mr-2"></i>
              Gå til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
